export const json = {
  completedHtml: 'Благодарим за сотрудничество!',
  pages: [
    {
      elements: [
        {
          choices: [
            'конкурс существенно влияет на повышение престижа профессии учителя',
            'конкурс влияет на повышение престижа учителей-участников конкурса',
            'конкурс не влияет на повышение престижа профессии учителя'
          ],
          name: '1_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» влияет на повышение престижа профессии учителя?',
          type: 'checkbox',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '2_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» можно рассматривать как способ популяризации профессии учителя?',
          type: 'radiogroup',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '3_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» можно рассматривать как механизм выявления и распространения лучших педагогических практик?',
          type: 'radiogroup',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '4_element',
          title:
            'Считаете ли Вы количество конкурсных испытаний для выявления победителя Конкурса-2020 достаточным?',
          type: 'radiogroup',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '5_1',
              title: 'оптимально и целесообразно',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '5_2',
              title: 'отражает специфику взаимодействия участников образовательных отношений',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '5_3',
              title: 'позволяет объективнее оценить выступление конкурсанта',
              type: 'radiogroup',
            },
            {
              name: '5_4',
              hideNumber: true,
              title: 'другое (укажите, что именно):',
              type: 'comment',
            },
          ],
          name: '5_element',
          showNumber: true,
          title:
            'Считаете ли Вы, что оценивание Большим, родительским и ученическим жюри конкурсных испытаний второго тура (отметьте выбранный ответ):',
          type: 'panel',
        },
        {
          elements: [
            {
              hideNumber: true,
              name: '6_1',
              title: ' ',
              type: 'comment',
            },
            {
              hideNumber: true,
              name: '6_2',
              title: 'Поясните, пожалуйста, свой ответ:',
              type: 'comment',
            },
          ],
          name: '6_element',
          showNumber: true,
          title:
            'Назовите конкурсное испытание второго и третьего туров финала Конкурса-2020, которое, на Ваш взгляд, вызвало самые большие затруднения у конкурсантов:',
          type: 'panel',
        },
        {
          choices: [
            'достаточна для оценки конкурсного испытания',
            'недостаточна для оценки конкурсного испытания',
            'соответствует специфике конкурсного испытания',
            'не в полной мере соответствует специфике конкурсного испытания',
          ],
          name: '7_element',
          hasOther: true,
          title:
            'На Ваш взгляд, оценка 30 баллов за конкурсное испытание «Методическая мастерская»:',
          type: 'checkbox',
        },
        {
          choices: [
            'сформулированы четко и понятно',
            'сформулированы недостаточно четко и понятно',
            'достаточны для оценки конкурсного испытания',
            'недостаточны для оценки конкурсного испытания',
            'соответствуют специфике конкурсного испытания',
            'не в полной мере соответствуют специфике конкурсного испытания'
          ],
          name: '8_element',
          hasOther: true,
          title:
            'Оцените формулировку критериев и показателей конкурсного испытания «Мастер-класс»:',
          type: 'checkbox',
        },
        {
          choices: [
            'сформулированы четко и понятно',
            'сформулированы недостаточно четко и понятно',
            'достаточны для оценки конкурсного испытания',
            'недостаточны для оценки конкурсного испытания',
            'соответствуют специфике конкурсного испытания',
            'не в полной мере соответствуют специфике конкурсного испытания'
          ],
          name: '9_element',
          hasOther: true,
          title:
            'Оцените формулировки критериев и показателей конкурсного испытания «Пресс-конференция «Вопрос учителю года»:',
          type: 'checkbox',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '10_1',
              title: 'оптимальны и целесообразны',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '10_2',
              title: 'соответствуют специфике внеурочной деятельности учителя',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '10_3',
              title: 'позволяют лауреатам продемонстрировать профессионально-личностные компетенции в области воспитания и социализации обучающихся',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '10_4',
              title: 'позволяют объективно оценить выступление конкурсанта',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '10_5',
              title: 'другое (укажите, что именно):',
              type: 'text',
            },
          ],
          name: '10_element',
          showNumber: true,
          title:
            'Насколько, на Ваш взгляд, регламент, формат и организация конкурсного испытания «Классный час» (время, отведенное на общение конкурсанта с обучающимися, дистанционное оценивание членами жюри этапа работы конкурсанта с обучающимися)',
          type: 'panel',
        },
        {
          name: '11_element',
          title:
            'Что вызвало у Вас затруднения при оценке конкурсных испытаний второго и третьего туров финала Конкурса?',
          type: 'comment',
        },
        {
          name: '12_element',
          title:
            'Ваши предложения по совершенствованию финала Конкурса:',
          type: 'comment',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '13_1',
              title: 'организация конкурсных испытаний:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '13_2',
              title: 'условия работы жюри:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '13_3',
              title: 'мероприятия по программе:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '13_4',
              title: 'информационное сопровождение',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '13_5',
              title: 'трансфер:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '13_6',
              title: 'проживание:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '13_7',
              title: 'питание:',
              type: 'radiogroup',
            },
          ],
          name: '13_element',
          showNumber: true,
          title:
            'Оцените уровень организации Вашего пребывания на заключительном этапе Конкурса-2020:',
          type: 'panel',
        },
      ],
      name: 'page1',
      showNumber: false,
      showQuestionNumbers: 'true',
      title:
        'Уважаемый эксперт! Просим Вас выразить свое мнение об организации и проведении Всероссийского конкурса «Учитель года России» 2020 года. Ваши ответы помогут при подготовке и проведении Всероссийского конкурса «Учитель года России» в 2021 году.',
    },
  ],
  showCompletedPage: true,
  title: 'АНКЕТА ЭКСПЕРТА БОЛЬШОГО ЖЮРИ финала Всероссийского конкурса «Учитель года России» 2020 года'
};
